import {AllPorts, OutPortsKeys} from "../../ElmFrameworkPorts";
import {InitConfig} from "../../Main";

export {
  handleAnalytics,
  send,
}


function handleAnalytics<SetUsrCtxPort extends OutPortsKeys>(config: InitConfig, ports: AllPorts): void {
  setUtmTag();
  ports.sendDetailedEvent?.subscribe(send);
}


function setUtmTag(): void {
  const utmTag = createUtmTag();
  if (utmTag.utm_source && utmTag.utm_campaign && utmTag.utm_medium) {
    send(utmTag);
  }


  function createUtmTag(): Partial<UtmTag> {
    const queryParams =
      window.location.search
        .slice(1)
        .split('&')
        .map(stringPair => stringPair.split('=').map(decodeURIComponent))
        .reduce((memo, [key, val]) => ({...memo, ...{[key]: val}}), {} as { [k: string]: string });
    return {
      utm_source: queryParams.utm_source,
      utm_medium: queryParams.utm_medium,
      utm_campaign: queryParams.utm_campaign,
      utm_term: queryParams.utm_term,
      utm_content: queryParams.utm_content,
    };
  }
}


const send = (data: GtmEvent | VirtualPageView | Partial<UtmTag> ): void => {
  window.gtm?.push(data);
};


type GtmEvent = { event: string } & Record<string, any>

interface VirtualPageView {
  event: 'virtual_page_view'
  virtual_page_url: string
  virtual_page_title: string
}

interface UtmTag {
  utm_source: string
  utm_medium: string
  utm_campaign: string
  utm_term?: string
  utm_content?: string
}


declare global {
  // @ts-ignore
  interface Window {
    gtm: any
  }
}

